import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@material-ui/core';

export default function PdfFilenameDialog({ open, defaultFilename, onConfirm, onCancel }) {
  const [filename, setFilename] = useState('');

  useEffect(() => {
    if (open && defaultFilename) {
      // Remove .pdf extension for easier editing
      setFilename(defaultFilename.replace('.pdf', ''));
    }
  }, [open, defaultFilename]);

  const handleConfirm = () => {
    const trimmed = filename.trim();
    if (trimmed.length === 0) return;

    // Ensure .pdf extension
    const finalFilename = trimmed.endsWith('.pdf') ? trimmed : `${trimmed}.pdf`;
    onConfirm(finalFilename);
    setFilename('');
  };

  const handleCancel = () => {
    onCancel();
    setFilename('');
  };

  const isValid = filename.trim().length > 0;

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Save PDF As</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Filename"
          type="text"
          fullWidth
          value={filename}
          onChange={(e) => setFilename(e.target.value)}
          helperText="Enter filename (extension will be added automatically)"
          onKeyPress={(e) => {
            if (e.key === 'Enter' && isValid) {
              handleConfirm();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={!isValid}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
}
